module.exports = __webpack_public_path__ + "img/down-xl3.8adad1ef.png";